import { Component } from '@angular/core'
import { RouterLink } from '@angular/router'
import {Input as RouteParam} from '@angular/core'


@Component({
    selector: 'lg-chantier-unauthorized',
    templateUrl: './chantier-unauthorized.component.html',
    imports: [RouterLink],
})
export class ChantierUnauthorizedComponent {
  @RouteParam()
  codeChantier: string
}
